<template>
  <div class="caseBox">
    <div class="boxTop">
      <p>
        {{ caseTitle.Name }}
      </p>
    </div>
    <div class="boxBottom">
      <div
        class="boxBottomItem"
        v-for="item in customerCaseList"
        :key="item.ID"
        @click="goCaseShow(item)"
      >
        <div class="itemImg">
          <!-- <img  src="./img/caseboxItem.png" alt=""> -->
          <img
            src="../../img/caseboxItem.png"
            v-lazy="item.TitlePic"
            :key="item.TitlePic"
            alt=""
          />
        </div>
        <p class="itemTitle">{{ item.Title }}</p>
        <p class="itemInfo">{{ item.Info }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { customerCase } from "@/api/client";
import request from "@/utils/request";
export default {
  props: {
    caseTitle: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      customerCaseList: [] // 用户中心列表
    };
  },
  mounted() {
    this.customerCase({ ID: this.caseTitle.ID });
  },

  methods: {
    // 客户案例中心
    async customerCase(data) {
      const res = await customerCase(data);
      // console.log(res, 'customerCasecustomerCase')
      if (res.Msg === "获取成功") {
        this.customerCaseList = res.Data;
        this.customerCaseList.forEach(item => {
          item.TitlePic = request.defaults.baseURL + item.TitlePic;
          // console.log(item.TitlePic, 'item.TitlePicitem.TitlePicitem.TitlePic')
        });
      }
    },
    goCaseShow(item) {
      this.$router.push({ path: `/caseShow/${item.ID}` });
    }
  }
};
</script>
<style lang="scss" scoped>
$md: 72/192 * 2;
.caseBox {
  width: 690px / $md;
  margin: auto;
  .boxTop {
    height: 50px / $md;
    border-bottom: 3px / $md solid #eee;
    margin-bottom: 40px / $md;
    p {
      width: 140px / $md;
      height: 50px / $md;
      border-bottom: 3px / $md solid #2380e1;
      color: #2380e1;
      text-align: center;
      font-weight: bold;
      letter-spacing: 2px / $md;
    }
  }
  .boxBottom {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .boxBottomItem {
    width: 318px / $md;
    height: 315px / $md;
    margin-bottom: 40px / $md;
    .itemImg {
      width: 266px / $md;
      height: 137px / $md;
      margin: auto;
      margin-bottom: 24px / $md;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .itemTitle {
      width: 297px / $md;
      margin: auto;
      font-size: 24px / $md;
      margin-bottom: 29px / $md;
      font-weight: bold;
      color: #333333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap; //溢出不换行
    }
    .itemInfo {
      height: 93px / $md;
      font-size: 18px / $md;
      font-weight: 400;
      line-height: 32px / $md;
      color: #666666;
      letter-spacing: 1px / $md;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
    }
  }
}
</style>
